import { HttpClient } from '@opallabs/api'
import loadWorkflow from '../loadWorkflow'

const prefixFor = (type, identifier) =>
  type && identifier ? `${type}/${identifier}/` : ''

const putRetractApprovals = ({ identifier, type, workflowId, phaseId }) =>
  HttpClient().put(
    `/api/v1/${prefixFor(
      type,
      identifier
    )}workflow/${workflowId}/phases/${phaseId}/retract`
  )

const retractApprovals =
  ({ identifier, type, onRetractApprovals, phaseId, workflowId }) =>
  (dispatch) =>
    putRetractApprovals({
      type,
      identifier,
      workflowId,
      phaseId,
    })
      .then((response) => {
        if (onRetractApprovals) {
          onRetractApprovals()
        }
        return dispatch(loadWorkflow(response.data))
      })
      .catch((err) => {
        console.log(err)
        throw err
      })

export default retractApprovals
